import _objectSpread from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React, { Fragment } from "react";
//Material imports
import IconButton from "@material-ui/core/IconButton";
import EditIcon from "@material-ui/icons/Edit";
import { withStyles } from "@material-ui/core/styles"; //Limitless imports

import { log as pilog } from "../../../../common/utils";
import RatingSystem from "./RatingSystem";
import RateYourExperienceFooter from "./RateYourExperienceFooter";

var CSATFooter = function CSATFooter(_ref) {
  var onClickHandle = _ref.onClickHandle,
      classes = _ref.classes,
      message = _ref.message,
      isTyping = _ref.isTyping;

  var _React$useState = React.useState({
    ratingVisible: message.customerScore !== null ? true : false,
    ratingDisabled: message.customerScore ? true : false
  }),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      localState = _React$useState2[0],
      setLocalState = _React$useState2[1];

  var ratingVisible = localState.ratingVisible,
      ratingDisabled = localState.ratingDisabled;
  var log = pilog.getLogger("CSATFooter");
  React.useEffect(function () {
    if (isTyping && !ratingDisabled) {
      setLocalState(_objectSpread({}, localState, {
        ratingDisabled: true
      }));
      log.debug({
        score: message.customerScore,
        ratingDisabled: true,
        isTyping: isTyping
      });
    }
  }, [isTyping]);

  var onClick = function onClick(voteCount) {
    setLocalState(_objectSpread({}, localState, {
      ratingDisabled: true
    }));
    onClickHandle(voteCount);
  };

  var renderRatingSystem = function renderRatingSystem() {
    if (ratingVisible) {
      return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: classes.ratingContainer
      }, /*#__PURE__*/React.createElement(RatingSystem, {
        onClick: onClick,
        message: message,
        useDefaultScore: false,
        disabled: ratingDisabled
      })), !isTyping && ratingDisabled && /*#__PURE__*/React.createElement(IconButton, {
        classes: {
          root: "".concat(classes.editButton, " ").concat(classes.borderRadius)
        },
        onClick: function onClick() {
          return setLocalState(_objectSpread({}, localState, {
            ratingDisabled: false
          }));
        },
        id: "editRatingButton"
      }, /*#__PURE__*/React.createElement(EditIcon, null)));
    }

    return /*#__PURE__*/React.createElement(RateYourExperienceFooter, {
      onClick: function onClick() {
        return setLocalState(_objectSpread({}, localState, {
          ratingVisible: true
        }));
      }
    });
  };

  return /*#__PURE__*/React.createElement("div", {
    className: classes.csatContainer
  }, renderRatingSystem());
};

var styles = function styles(_ref2) {
  var background = _ref2.background;
  return {
    csatContainer: {
      position: "relative",
      display: "flex",
      flex: "1",
      justifyContent: "space-around",
      alignItems: "center",
      borderTop: "2px solid rgba(0, 0, 0, 0.06)"
    },
    ratingContainer: {
      width: "70%"
    },
    rateExperienceBtn: {
      height: 44
    },
    editButton: {
      height: 44,
      width: 44,
      padding: 8,
      position: "absolute",
      right: 0,
      top: 5,
      "&:hover": {
        backgroundColor: background.default
      }
    },
    borderRadius: {
      borderBottomRightRadius: 12
    }
  };
};

export default withStyles(styles, {
  withTheme: true
})(CSATFooter);